
import WorkstationLayout from '../layouts/workstation/Layout';
import PublicLayout from '../layouts/public/Layout';

import PasswordPage from '../pages/workstation/account/PasswordPage';
import ProfilePage from '../pages/workstation/account/ProfilePage';
import LoginPage from '../pages/workstation/access/LoginPage';
import DashboardPage from '../pages/workstation/dashboard/DashboardPage';

import ProductsPage from '../pages/workstation/products/ProductsPage';
import ProductViewPage from '../pages/workstation/products/ProductViewPage';

import CashSalesPage from '../pages/workstation/documents/cash_sales/CashSalesPage';
import CashSalesNewPage from '../pages/workstation/documents/cash_sales/CashSalesNewPage';
import CashSalesViewPage from '../pages/workstation/documents/cash_sales/CashSalesViewPage';
import CashSalesVerifyQutPage from '../pages/workstation/documents/cash_sales/CashSalesVerifyOutPage';

import DeliveryOrdersPage from '../pages/workstation/documents/delivery_orders/DeliveryOrdersPage';
import DeliveryOrderNewPage from '../pages/workstation/documents/delivery_orders/DeliveryOrderNewPage';
import DeliveryOrderUpdatePage from '../pages/workstation/documents/delivery_orders/DeliveryOrderUpdatePage';
import DeliveryOrderViewPage from '../pages/workstation/documents/delivery_orders/DeliveryOrderViewPage';
import DeliveryOrderVerifyQutPage from '../pages/workstation/documents/delivery_orders/DeliveryOrderVerifyOutPage';

import ReplacementDeliveriesPage from '../pages/workstation/documents/replacement_delivery/ReplacementDeliveriesPage';
import ReplacementDeliveryNewPage from '../pages/workstation/documents/replacement_delivery/ReplacementDeliveryNewPage'
import ReplacementDeliveryUpdatePage from '../pages/workstation/documents/replacement_delivery/ReplacementDeliveryUpdatePage'
import ReplacementDeliveryViewPage from '../pages/workstation/documents/replacement_delivery/ReplacementDeliveryViewPage';
import ReplacementDeliveryVerifyOutPage from '../pages/workstation/documents/replacement_delivery/ReplacementDeliveryVerifyOutPage';

import PurchaseReturnsPage from '../pages/workstation/documents/purchase_returns/PurchaseReturnsPage';
import PurchaseReturnNewPage from '../pages/workstation/documents/purchase_returns/PurchaseReturnNewPage';
import PurchaseReturnUpdatePage from '../pages/workstation/documents/purchase_returns/PurchaseReturnUpdatePage';
import PurchaseReturnViewPage from '../pages/workstation/documents/purchase_returns/PurchaseReturnViewPage';
import PurchaseReturnVerifyOutPage from '../pages/workstation/documents/purchase_returns/PurchaseReturnVerifyOutPage';

import ItemReceivesPage from '../pages/workstation/documents/item_receives/ItemReceivesPage';
import ItemReceiveNewPage from '../pages/workstation/documents/item_receives/ItemReceiveNewPage';
import ItemReceiveUpdatePage from '../pages/workstation/documents/item_receives/ItemReceiveUpdatePage';
import ItemReceiveViewPage from '../pages/workstation/documents/item_receives/ItemReceiveViewPage';
import ItemReceiveVerifyInPage from '../pages/workstation/documents/item_receives/ItemReceiveVerifyInPage';

import ItemTransfersPage from '../pages/workstation/documents/item_transfers/ItemTransfersPage';
import ItemTransferNewPage from '../pages/workstation/documents/item_transfers/ItemTransferNewPage';
import ItemTransferUpdatePage from '../pages/workstation/documents/item_transfers/ItemTransferUpdatePage';
import ItemTransferViewPage from '../pages/workstation/documents/item_transfers/ItemTransferViewPage';
import ItemTransferVerifyTransferInPage from '../pages/workstation/documents/item_transfers/ItemTransferVerifyTransferInPage'
import ItemTransferVerifyOutPage from '../pages/workstation/documents/item_transfers/ItemTransferVerifyOutPage';

import ItemRelocatesPage from '../pages/workstation/documents/item_relocates/ItemRelocatesPage';
import ItemRelocateNewPage from '../pages/workstation/documents/item_relocates/ItemRelocateNewPage';
import ItemRelocateViewPage from '../pages/workstation/documents/item_relocates/ItemRelocateViewPage';

import ItemTransformPage from '../pages/workstation/documents/item_transform/ItemTransformPage';
import ItemTransformNewPage from '../pages/workstation/documents/item_transform/ItemTransformNewPage';

import StockTakesPage from '../pages/workstation/documents/stock_takes/StockTakesPage';
import StockTakeNewPage from '../pages/workstation/documents/stock_takes/StockTakeNewPage';
import StockTakeUpdatePage from '../pages/workstation/documents/stock_takes/StockTakeUpdatePage';
import StockTakeViewPage from '../pages/workstation/documents/stock_takes/StockTakeViewPage';
import StockTakeExecutePage from '../pages/workstation/documents/stock_takes/StockTakeExecutePage';

import TripOrdersPage from '../pages/workstation/documents/trip_orders/TripOrdersPage';
import TripOrderNewPage from '../pages/workstation/documents/trip_orders/TripOrderNewPage';
import TripOrderUpdatePage from '../pages/workstation/documents/trip_orders/TripOrderUpdatePage';
import TripOrderViewPage from '../pages/workstation/documents/trip_orders/TripOrderViewPage';

import PackagesPage from '../pages/workstation/repositories/packages/PackagesPage';
import PackageNewPage from '../pages/workstation/repositories/packages/PackageNewPage';
import PackagePackPage from '../pages/workstation/repositories/packages/PackagePackPage';
import PackageViewPage from '../pages/workstation/repositories/packages/PackageViewPage';

import ItemRelocateThresholdPage from '../pages/workstation/operations/relocateThreshold/ItemRelocateThresholdPage';
import ViewInventoryPage from '../pages/workstation/operations/inventory/ViewInventoryPage';

// import DeliveryOrdersPage from '../pages/workstation/documents/unuse/delivery_orders/DeliveryOrdersPage';
// import DeliveryOrderViewPage from '../pages/workstation/documents/unuse/delivery_orders/DeliveryOrderViewPage';

// import PickingOrdersPage from '../pages/workstation/documents/picking_orders/PickingOrdersPage';

// import PackingOrdersPage from '../pages/workstation/documents/unuse/packing_orders/PackingOrdersPage';
// import PackingOrderViewPage from '../pages/workstation/documents/unuse/packing_orders/PackingOrderViewPage';


// import TripOrdersPage from '../pages/workstation/documents/unuse/trip_orders/TripOrdersPage';
// import TripOrderViewPage from '../pages/workstation/documents/unuse/trip_orders/TripOrderViewPage';

// Modules (Chinlai Hardware)
// import PickingOrdersRequestsPage from '../pages/workstation/modules/chinlaihardware/PickingOrdersRequestsPage';
// import PackingOrdersCartonPage from '../pages/workstation/modules/chinlaihardware/bbkbk_PackingOrdersCartonPage';

// Modules (Wing Huong)
// import DeliveryFeeCalculatorPage from '../pages/workstation/modules/winghuong/DeliveryFeeCalculatorPage';
// import ImportPage from "../pages/workstation/modules/winghuong/ImportPage"

export default function routes() {

    return [
        {
            path: '/workstation',
            element: <PublicLayout />,
            children: [
                // { element: <Navigate to="dashboard" />, index: true },
                { path: 'login', element: <LoginPage /> },
            ],
        },
        {
            path: '/workstation',
            element: <WorkstationLayout />,
            children: [
                // { element: <Navigate to="dashboard" />, index: true },
                { path: '', element: <DashboardPage /> },

                { path: 'dashboard', element: <DashboardPage /> },
                { path: 'profile', element: <ProfilePage /> },
                { path: 'password', element: <PasswordPage /> },

                { path: 'products', element: <ProductsPage /> },
                { path: 'product/view/:id', element: <ProductViewPage /> },

                { path: 'documents/cashSales', element: <CashSalesPage /> },
                { path: 'documents/cashSales/new', element: <CashSalesNewPage /> },
                { path: 'documents/cashSales/view/:id', element: <CashSalesViewPage /> },
                // { path: 'documents/cashSales/stockPost/:id', element: <CashSalesStockPostPage /> },
                { path: 'documents/cashSales/verifyOut/:id', element: <CashSalesVerifyQutPage /> },

                { path: 'documents/deliveryOrders', element: <DeliveryOrdersPage /> },
                { path: 'documents/deliveryOrder/new', element: <DeliveryOrderNewPage /> },
                { path: 'documents/deliveryOrder/update/:id', element: <DeliveryOrderUpdatePage /> },
                { path: 'documents/deliveryOrder/view/:id', element: <DeliveryOrderViewPage /> },
                { path: 'documents/deliveryOrder/verifyOut/:id', element: <DeliveryOrderVerifyQutPage /> },

                { path: 'documents/replacementDeliveries', element: <ReplacementDeliveriesPage /> },
                { path: 'documents/replacementDelivery/new', element: <ReplacementDeliveryNewPage /> },
                { path: 'documents/replacementDelivery/update/:id', element: <ReplacementDeliveryUpdatePage /> },
                { path: 'documents/replacementDelivery/view/:id', element: <ReplacementDeliveryViewPage /> },
                { path: 'documents/replacementDelivery/verifyOut/:id', element: <ReplacementDeliveryVerifyOutPage /> },

                { path: 'documents/purchaseReturns', element: <PurchaseReturnsPage /> },
                { path: 'documents/purchaseReturn/new', element: <PurchaseReturnNewPage /> },
                { path: 'documents/purchaseReturn/update/:id', element: <PurchaseReturnUpdatePage /> },
                { path: 'documents/purchaseReturn/view/:id', element: <PurchaseReturnViewPage /> },
                { path: 'documents/purchaseReturn/verifyOut/:id', element: <PurchaseReturnVerifyOutPage /> },

                { path: 'documents/itemReceives', element: <ItemReceivesPage /> },
                { path: 'documents/itemReceive/new', element: <ItemReceiveNewPage /> },
                { path: 'documents/itemReceive/update/:id', element: <ItemReceiveUpdatePage /> },
                { path: 'documents/itemReceive/view/:id', element: <ItemReceiveViewPage /> },
                { path: 'documents/itemReceive/verifyIn/:id', element: <ItemReceiveVerifyInPage /> },

                { path: 'documents/itemTransfers', element: <ItemTransfersPage /> },
                { path: 'documents/itemTransfer/new', element: <ItemTransferNewPage /> },
                { path: 'documents/itemTransfer/update/:id', element: <ItemTransferUpdatePage /> },
                { path: 'documents/itemTransfer/view/:id', element: <ItemTransferViewPage /> },
                { path: 'documents/itemTransfer/verifyTransferIn/:id', element: <ItemTransferVerifyTransferInPage /> },
                { path: 'documents/itemTransfer/verifyOut/:id', element: <ItemTransferVerifyOutPage /> },

                { path: 'documents/itemRelocates', element: <ItemRelocatesPage /> },
                { path: 'documents/itemRelocate/new', element: <ItemRelocateNewPage /> },
                { path: 'documents/itemRelocate/view/:id', element: <ItemRelocateViewPage /> },

                { path: 'documents/itemTransform', element: <ItemTransformPage /> },
                { path: 'documents/itemTransform/new', element: <ItemTransformNewPage /> },

                { path: 'documents/stockTakes', element: <StockTakesPage /> },
                { path: 'documents/stockTake/new', element: <StockTakeNewPage /> },
                { path: 'documents/stockTake/update/:id', element: <StockTakeUpdatePage /> },
                { path: 'documents/stockTake/view/:id', element: <StockTakeViewPage /> },
                { path: 'documents/stockTake/execute/:id', element: <StockTakeExecutePage /> },

                { path: 'documents/tripOrders', element: <TripOrdersPage /> },
                { path: 'documents/tripOrder/new', element: <TripOrderNewPage /> },
                { path: 'documents/tripOrder/update/:id', element: <TripOrderUpdatePage /> },
                { path: 'documents/tripOrder/view/:id', element: <TripOrderViewPage /> },

                { path: 'repositories/packages', element: <PackagesPage /> },
                { path: 'repositories/package/new', element: <PackageNewPage /> },
                { path: 'repositories/package/pack', element: <PackagePackPage /> },
                { path: 'repositories/package/view', element: <PackageViewPage /> },

                { path: 'operations/itemThreshold/relocate', element: <ItemRelocateThresholdPage /> },
                { path: 'operations/inventory/examine', element: <ViewInventoryPage /> },

                // { path: 'documents/deliveryOrders', element: <DeliveryOrdersPage /> },
                // { path: 'documents/deliveryOrder/view/:id', element: <DeliveryOrderViewPage /> },

                // { path: 'documents/packingOrders', element: <PackingOrdersPage /> },
                // { path: 'documents/packingOrder/view/:id', element: <PackingOrderViewPage /> },

                // { path: 'documents/tripOrders', element: <TripOrdersPage /> },
                // { path: 'documents/tripOrder/view/:id', element: <TripOrderViewPage /> },

                // { path: 'repositories/packages', element: <PackagesPage /> },
                // { path: 'repositories/package/new', element: <PackageNewPage /> },
                // { path: 'repositories/package/pack', element: <PackagePackPage /> },
                // { path: 'repositories/package/view', element: <PackageViewPage /> },


                // { path: 'modules/chinlaihardware/pickingOrdersRequests', element: <PickingOrdersRequestsPage /> },
                // { path: 'modules/chinlaihardware/packingOrdersCarton', element: <PackingOrdersCartonPage /> },

                // { path: 'modules/winghuong/deliveryFeeCalculator', element: <DeliveryFeeCalculatorPage /> },

                // { path: 'modules/winghuong/import', element: <ImportPage /> }

            ],
        }
    ]
}